import * as v from 'valibot';
import { integerInRange } from '../util/valibot';
export const panelGroupSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    panel_id: integerInRange(0, 0xffffffff),
    title: v.string(),
    ord: integerInRange(0, 0xffffffff)
});
